const mapping = {
  lo: "la",
  vi: "vn",
  en: "gb",
};

const convertLanguageNametoCountryName = (languageName) => {
  return mapping[languageName] ? mapping[languageName] : "null";
};

const chunkArray = (arr, len) => {
  let chunks = [],
    i = 0,
    n = arr.length;

  while (i < n) {
    chunks.push(arr.slice(i, (i += len)));
  }

  return chunks;
};

export { convertLanguageNametoCountryName, chunkArray };
